"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Field = {
    FIRST_NAME: 0,
    LAST_NAME: 1,
    GENDER: 2,
    BIRTHDATE: 3,
    REGION: 4,
    SCHEDULE: 5,
    DOCTOR: 6,
    CITY: 7,
    RELATIONSHIP: 8,
    NOTES: 9,
    IGNORED_GENERATORS: 10,
    DOSE_COMMENTS: 11,
    CONCEPT: 0,
    DATE: 1,
    RECEIVED: 2,
    GTIN: 3,
    LOT_NUMBER: 4,
    EXPIRY: 5,
    COMMENTS: 6,
    NAME: 0,
    MFA_ENABLED: 1,
    PUSH_ENABLED: 2,
    CONSENT: 4
};
//# sourceMappingURL=Field.js.map